import { useTranslation } from 'react-i18next';
import type { AddressBlockData } from '@foco/contracts';
import { CopyableValue, Field, FieldGrid } from './primitives';

/** Legal address, exactly as the registry publishes it. */
export function AddressBlock({ data }: { data: unknown }): React.ReactNode {
  const { t } = useTranslation();
  const block = (data ?? {}) as AddressBlockData;

  return (
    <FieldGrid>
      <div className="sm:col-span-2">
        <Field label={t('blocks.address.line')}>
          <CopyableValue value={block.line} />
        </Field>
      </div>
      <Field label={t('blocks.address.city')}>
        <CopyableValue value={block.city} />
      </Field>
      <Field label={t('blocks.address.state')}>
        <CopyableValue value={block.state} />
      </Field>
      <Field label={t('blocks.address.postalCode')}>
        <CopyableValue value={block.postalCode} mono />
      </Field>
      <Field label={t('blocks.address.country')}>
        <CopyableValue value={block.country} />
      </Field>
    </FieldGrid>
  );
}
